// Base URL for the server
// let baseUrl: string = window.location.hostname+":8081";
// let baseUrl: string = window.location.hostname+":8000";
// if (window.location.protocol != "https:") {
//   baseUrl = "http://" + baseUrl;
// }else{
//   baseUrl = "https://" + baseUrl;
// }
const baseUrl: string = 'https://' + (process.env.VUE_APP_BASE_URL || 'localhost:8000');

// const baseUrl: string = 'http://192.168.10.179:8000';
// const baseUrl: string = 'https://backend-devdocs.dshop.company';
            
// URL for fetching the order related documents
export const orderApiUrl: string = baseUrl + '/mailapp/order-document-api/';
export const loginApiUrl: string = baseUrl + '/accounts-api/login-api/';
export const logoutApiUrl: string = baseUrl + '/accounts-api/logout-api/';
export const documentUploadApiUrl: string = baseUrl + '/mailapp/document-upload-api/';
export const emailTemplateUploadApiUrl: string = baseUrl + '/mailapp/email-template-api/';
export const emailReportApiUrl: string = baseUrl + '/reports/email-template-report-api/';
export const documentReportApiUrl: string = baseUrl + '/reports/document-report-api/';
export const documentAddedReportApiUrl: string = baseUrl + '/reports/document-added-report-api/';
export const rmaFilterApiUrl: string = baseUrl + "/rma/rma-api/";
export const addNewRmaApiUrl: string = baseUrl + "/rma/rma-search-filter/";
export const addNewRmaPostApiUrl: string = baseUrl + "/rma/rma-sku-list/";
export const RmaStatusPostApiUrl:string = baseUrl + '/rma/rma-status-save/';
export const CloseRmaPostApiUrl:string = baseUrl + '/rma/rma-close-mark/';
export const DetailsOnPageLoadApiUrl = baseUrl+'/rma/rma-details-page-load/';
export const SendInBlueAuthApiUrl = baseUrl+'/send-in-blue-auth/'